import { gql } from '@apollo/client';

const CUSTOM_ENTRIES = gql`
  query Query($input: fetchCustomListInput) {
    Listcustoms(input: $input)
  }
`;

export const MATERIAL_LIST = gql`
  query Query($input: MaterialsListInput) {
    MaterialsList(input: $input)
  }
`;
export const CONSOLIDATED_BOOKINGS = gql`
  query Query($input: CustomBookingListInput) {
    CustomBookingList(input: $input)
  }
`;

export const CONSOLIDATED_SHIPMENT = gql`
  query Query($input: ConsolidatedShipmentListInput) {
    ConsolidatedShipmentList(input: $input)
  }
`;

export default CUSTOM_ENTRIES;
